const PasswordModal = ({
  isOpen,
  password,
  onClose,
}: {
  isOpen: boolean;
  password: any;
  onClose: any;
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-80 max-w-md mx-4">
        <h2 className="text-lg font-bold mb-4">Profile Password</h2>
        <div className="bg-gray-100 p-3 rounded border">
          <p className="text-sm font-mono break-all">{password}</p>
        </div>
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordModal